/**
 * Removes an item in an array without modifiying it, returning a new array with the item removed
 */
export default function arrayRemove<T>(arr: readonly T[], index: number): T[] {
  const arrCopy = arr.slice();
  arrCopy.splice(index, 1);
  return arrCopy;
}
